module.exports = __webpack_public_path__ + "img/maas.02e22740.png";